var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65707 21.6611C8.65707 21.6611 11.2168 11.0019 11.4699 10.3333C9.02479 10.5673 9.80799 16.298 12.5778 16.9237C14.9227 17.4728 17.5206 14.7555 17.4824 11.7421C17.4442 8.7287 15.6724 7.22438 13.4327 6.59877C11.1929 5.97317 7.63031 6.74682 6.68474 9.87962C6.34593 10.8309 6.3014 11.8622 6.55693 12.8392C6.81246 13.8162 7.35623 14.6936 8.11742 15.3573M12 1.73242C9.96926 1.73242 7.98413 2.3346 6.29564 3.46282C4.60715 4.59104 3.29113 6.19461 2.514 8.07076C1.73687 9.94692 1.53354 12.0114 1.92972 14.0031C2.32589 15.9948 3.30378 17.8243 4.73973 19.2603C6.17567 20.6962 8.00518 21.6741 9.99689 22.0703C11.9886 22.4665 14.0531 22.2631 15.9292 21.486C17.8054 20.7089 19.409 19.3928 20.5372 17.7044C21.6654 16.0159 22.2676 14.0307 22.2676 12C22.2663 9.27725 21.1841 6.66639 19.2589 4.74112C17.3336 2.81585 14.7227 1.73369 12 1.73242Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.dfb62935cdad0748cf6816dc2f7579e5.svg";
export { ForwardRef as ReactComponent };